
import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => {
    return {
      root: {
        maxWidth: "100%",
        backgroundColor: "white",
        alignItems: "center",
        flexDirection: "row",
        marginBottom: 5,
        [theme.breakpoints.up("md")]: {
          marginBottom: 10,
          width: "100%"
        },
      },
      container:{
        display:"block",
        [theme.breakpoints.up("md")]: {
          display: "flex",
        },
      },
      body: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
    
        [theme.breakpoints.up("md")]: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
 
          padding: 0,
          "&:last-child": {
            paddingBottom: 0,
    
          },
        },
      },
      main: {
        flexDirection: "row",
        display: "flex",
        justifyContent:"space-between",
        width:"100%",
        alignItems: "flex-start"
      },
      content1: {
        textAlign: "start",
        alignItems: "center",
        justifyContent: "flex-start",
        [theme.breakpoints.up("md")]: {
          alignItems: "flex-start",
          justifyContent: "center",
          textAlign: "start",
        },
      },
      content2: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "center",
        [theme.breakpoints.up("md")]: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "row",
          textAlign: "start",
          padding: 0,
          "&:last-child": {
            paddingBottom: 0,
          },
        },
      },
      popover: {
        [theme.breakpoints.up("md")]: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
      },
      text: {
        marginBottom: 10,
        [theme.breakpoints.up("md")]: {
          marginBottom: 0,
        },
      },
    };
  });